import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-database",
  "use": "icon-database-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-database\"><path d=\"M8 2c-3.314 0-6 .895-6 2v8c0 1.105 2.686 2 6 2s6-.895 6-2V4c0-1.105-2.686-2-6-2m0 1c2.764 0 4.44.63 4.909 1-.469.37-2.145 1-4.909 1s-4.44-.63-4.909-1C3.56 3.63 5.236 3 8 3m0 10c-2.989 0-4.706-.737-5-1.085v-2.81C4.075 9.644 5.912 10 8 10s3.925-.356 5-.895v2.811C12.706 12.263 10.989 13 8 13m5-5c-.47.37-2.236 1-5 1s-4.53-.63-5-1V5.105C4.075 5.644 5.912 6 8 6s3.925-.356 5-.895z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol